// dashboard components
const Dashboard = () => import("Modules/dashboard/views/Dashboard");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "dashboard",
            name: "dashboard",
            component: Dashboard,
            meta: {
                requiresAuth: true,
                title: "lang.ecommerce",
            },
        },
    ],
};
